// VFX: Dust Particles Float
// Category: overlays · Tags: dust, particles, float, organic, atmosphere
// Tiny dust motes drift upward — organic cinematic atmosphere.
import { AbsoluteFill, useCurrentFrame, useVideoConfig, random } from "remotion";
import React from "react";

const COUNT = 60;

export default function DustParticlesFloat() {
  const frame = useCurrentFrame();
  const { width, height, durationInFrames } = useVideoConfig();
  const particles = Array.from({ length: COUNT }, (_, i) => {
    const seedX = random(`x-${i}`);
    const seedY = random(`y-${i}`);
    const seedS = random(`s-${i}`);
    const seedSp = random(`sp-${i}`);
    const seedO = random(`o-${i}`);
    const size = 2 + seedS * 5;
    const speed = 0.3 + seedSp * 0.7;
    const baseY = seedY * height;
    const y = (baseY - frame * speed) % (height + 100);
    const yWrapped = y < -50 ? y + height + 100 : y;
    const x = seedX * width + Math.sin((frame + i * 7) * 0.02) * 30;
    const opacity = 0.3 + seedO * 0.5;
    return { x, y: yWrapped, size, opacity, key: i };
  });
  return (
    <AbsoluteFill style={{ pointerEvents: "none", background: "transparent" }}>
      {particles.map((p) => (
        <div key={p.key} style={{
          position: "absolute",
          left: p.x, top: p.y,
          width: p.size, height: p.size,
          borderRadius: "50%",
          background: "rgba(255,255,255,0.85)",
          boxShadow: `0 0 ${p.size * 2}px rgba(255,255,255,0.5)`,
          opacity: p.opacity,
          filter: "blur(0.5px)",
        }} />
      ))}
    </AbsoluteFill>
  );
}

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
